__turbopack_context__.v({
  "chevron": "LanguagePicker-module-scss-module__8YmU2G__chevron",
  "chevronOpen": "LanguagePicker-module-scss-module__8YmU2G__chevronOpen",
  "code": "LanguagePicker-module-scss-module__8YmU2G__code",
  "compactOnMobile": "LanguagePicker-module-scss-module__8YmU2G__compactOnMobile",
  "dropIn": "LanguagePicker-module-scss-module__8YmU2G__dropIn",
  "dropdown": "LanguagePicker-module-scss-module__8YmU2G__dropdown",
  "flag": "LanguagePicker-module-scss-module__8YmU2G__flag",
  "option": "LanguagePicker-module-scss-module__8YmU2G__option",
  "optionActive": "LanguagePicker-module-scss-module__8YmU2G__optionActive",
  "optionLabel": "LanguagePicker-module-scss-module__8YmU2G__optionLabel",
  "picker": "LanguagePicker-module-scss-module__8YmU2G__picker",
  "trigger": "LanguagePicker-module-scss-module__8YmU2G__trigger",
});
